import React from "react";
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import { Field, reduxForm, getFormValues, change } from "redux-form";

import { UnstiledDropdownListField } from "../common/Inputs";
import DateTimeField from "../common/DateTimeField";
import { states } from '../../constants/orderStates';
import * as constants from '../../constants/analytics';
import { connect } from 'react-redux';

const validate = (values) => {
    const { endDateFilter, startDateFilter, reportTypeFilter } = values;
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }
    required('reportTypeFilter');
    required('startDateFilter');
    required('endDateFilter');
    required('stateFilter');

    if (startDateFilter > endDateFilter)
        errors['startDateFilter'] = '*Дата начала не может быть больше даты окончания';

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (endDateFilter && currentDate < endDateFilter)
        errors['endDateFilter'] = '*Дата окончания не может быть больше текущей даты';

    return errors;
}
let AnalyticsFilter = class extends React.Component {
    constructor(props) {
        super(props);
        this._onStartDateSelected = this._onStartDateSelected.bind(this);
    }

    componentDidMount() {
        const { change } = this.props;
        var endDate = new Date();
        var startDate = new Date();
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        startDate.setDate(endDate.getDate() - 30);
        change('startDateFilter', startDate);
        change('endDateFilter', endDate);
        change('reportTypeFilter', constants.reportTypes[0]);
        change('stateFilter', states[0]);
    }

    _onStartDateSelected(e, val) {
        const now = new Date();
        if (val.getDate() === now.getDate() && val.getMonth() === now.getMonth() && val.getFullYear() === now.getFullYear())
            this.props.change('endDateFilter', val);
    }
    render() {
        const { showOrderStateFilter } = this.props;
        return (
            <Grid fluid={true} >
                <Row>
                    <Col lg={12}>
                        <Panel>
                            <Panel.Heading>Фильтр</Panel.Heading>
                            <Panel.Body>
                                {<form className='form-horizontal' >
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label>Отчет</label>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Дата начала</label>
                                        </div>
                                        <div className="col-md-2">
                                            <label>Дата окончания</label>
                                        </div>
                                        {showOrderStateFilter && <div className="col-md-2">
                                            <label>Статус</label>
                                        </div>}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2">
                                            <Field
                                                name='reportTypeFilter'
                                                component={UnstiledDropdownListField}
                                                data={constants.reportTypes}
                                                valueField='Id'
                                                textField='Name' />
                                        </div>
                                        <div className="col-md-2">
                                            <Field
                                                name='startDateFilter'
                                                component={DateTimeField}
                                                time={false}
                                                max={new Date()}
                                                dateTimeFormat='DD-MM-YYYY'
                                                onChange={this._onStartDateSelected} />
                                        </div>
                                        <div className="col-md-2">
                                            <Field
                                                name='endDateFilter'
                                                component={DateTimeField}
                                                time={false}
                                                max={new Date()}
                                                dateTimeFormat='DD-MM-YYYY' />
                                        </div>
                                        {showOrderStateFilter && <div className="col-md-2">
                                            <Field
                                                name='stateFilter'
                                                component={UnstiledDropdownListField}
                                                data={states}
                                                valueField='Id'
                                                textField='Name' />
                                        </div>}
                                    </div>
                                </form>}
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </Grid >
        )
    }
}

AnalyticsFilter = reduxForm({
    form: 'AnalyticsFilter',
    validate
})(AnalyticsFilter);

function mapToProps(state, props) {
    const formValues = getFormValues('AnalyticsFilter')(state);
    var errors = formValues ? validate(formValues) : undefined;
    const showOrderStateFilter = formValues && formValues.reportTypeFilter != null ? constants.showOrderStateFilter(formValues.reportTypeFilter) : false;

    if (errors && Object.keys(errors).length > 0) {
        props.setUpdateButtonEnable(false);
    }
    else {
        props.setUpdateButtonEnable(true);
    }
    return {
        showOrderStateFilter
    }
}

AnalyticsFilter = connect(mapToProps, { getFormValues })(AnalyticsFilter);

export default AnalyticsFilter;


// WEBPACK FOOTER //
// ./src/components/analytics/AnalyticsFilter.jsx